<script setup lang="ts">
import type { CmsElementZebraCmsMarqueebanner } from "~/composables/useCustom";
import Marquee from "./Marquee.vue";

const props = defineProps<{
  content: CmsElementZebraCmsMarqueebanner;
}>();

const loading = ref(false);

const { hexcode_bg, hexcode_text, marquee_speed, marquee_text } =
  props.content?.config;

const speed = computed(() => {
  if (marquee_speed.value == "speed_low") {
    return 30;
  } else if (marquee_speed.value == "speed_mid") {
    return 60;
  } else {
    return 100;
  }
});
</script>
<template>
  <div v-if="marquee_text.value" class="marquee-section relative">
    <div :style="{ 'background-color': hexcode_bg.value }">
      <div
        class="py-4 lg:py-8 uppercase "
        :style="{ color: hexcode_text.value }"
      >
        <Marquee :text="marquee_text.value" :speed="speed" />
      </div>
    </div>
  </div>
</template>
